import React, { ChangeEvent } from 'react';

interface TrainingListLabelInputProps {
  label: string;
  id: string;
  type: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const TrainingListLabelInput: React.FC<TrainingListLabelInputProps> = ({
  label,
  id,
  type,
  value,
  onChange,
  placeholder
}) => (
  <div className="form-group d-flex align-items-center mx-1">
    <label htmlFor={id} className="control-label mx-1">
      {label}
    </label>
    <input
      id={id}
      type={type}
      className="form-control"
      style={{ width: '250px' }}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </div>
);

export default TrainingListLabelInput;